<template>
  <label class="radio-wrapper" :class="{active: checked}">
    <input type="radio" :value="value" :name="radioGroupName" class="cdk-visually-hidden" v-on="$listeners" />
    {{ label }}
  </label>
</template>

<script>
export default {
  name: 'RadioInput',
  props: {
    label: {
      type: String,
      default: '',
    },
    radioGroupName: {
      type: String,
      default: 'radio',
    },
    checked: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Boolean, String],
      default: false,
    },
  },
};
</script>

<style scoped>
.cdk-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

.radio-wrapper {
  border-radius: 100px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 118.14%;
  text-align: center;
  letter-spacing: -0.005em;
  color: #fff;
  padding: 5px 8px 3px;
  cursor: pointer;
  transition: background-color 0.2s linear, color 0.2s linear;
}

.radio-wrapper.active {
  background: #ffffff;
  color: #071d3b;
}
</style>
